export const firebaseConfig = {
  apiKey: 'AIzaSyBrMUMq8lJDUJZSWzXB3aR0ShgGHwLjcoc',
  authDomain: 'bookshelf-239408.firebaseapp.com',
  databaseURL: 'https://bookshelf-239408.firebaseio.com',
  projectId: 'bookshelf-239408',
  storageBucket: 'bookshelf-239408.appspot.com',
  messagingSenderId: '489604966508',
  appId: '1:489604966508:web:c949ddc4eee36e6e485049',
};
